var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiotIconUncolored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "riot-icon-uncolored_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h16v16H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#riot-icon-uncolored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.833 5.462L9.31 2l5.857 1.467v7.676l-2.423.298-.967-5.483-.466.208.471 5.393-2.45.301-.885-5.013-.46.205.43 4.92-2.423.298-.804-4.557-.466.207.39 4.458-1.418.174-1.863-7.09zm7.776 7.989l-.123-.698h.003l5.678-.698v2.322l-5.558-.926z",
    fill: "currentColor"
  }))));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/riot-icon-uncolored.svg";
export { SvgRiotIconUncolored as ReactComponent };